import { __awaiter } from "tslib";
import '@slickdeals/blueprint-twig/javascript/components/heading2';
import '@slickdeals/blueprint-twig/javascript/components/heading4';
import '@slickdeals/blueprint-twig/javascript/patterns/articleContentListModule';
import '@slickdeals/blueprint-twig/javascript/patterns/avatarImage';
import '@slickdeals/blueprint-twig/javascript/patterns/couponContentListModule';
import '@slickdeals/blueprint-twig/javascript/patterns/dealContentListModule';
import '@slickdeals/blueprint-twig/javascript/patterns/dealLink';
import '@slickdeals/blueprint-twig/javascript/patterns/storeCardGrid';
import '@slickdeals/blueprint-twig/javascript/patterns/storeLink';
import '@slickdeals/blueprint-twig/javascript/patterns/storeCouponCard';
import './standalonePageEntrypointBanner';
import '../components/linkList';
import '../patterns/cashbackTag';
import '../patterns/commentInlineReply';
import '../patterns/expertLabel';
import '../patterns/sidebarDeals';
import '../patterns/cashbackActivator';
import '../patterns/inlineResponse';
import readyState from 'ready-state';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import { name as JobSubscriberName, QOSLevels } from '@slickdeals/blueprint-twig/javascript/queues/jobQueue/jobSubscriber';
import Blueshift from '../blueshift/blueshift';
import BlueshiftObserver from '../blueshift/blueshiftObserver';
import Heap from '../heap/heap';
import { name as ButtonObserverName } from '../button/buttonObserver';
import { injectCashbackTag } from '../loyalty/dealDetailCashbackTagInjector';
import DealDetailsPageOutClickObservable from '../observers/dealDetailsPageOutClickObservable';
import DealDetailsPageViewObservable from '../observers/dealDetailsPageViewObservable';
import LoyaltyOfferService from '../services/loyaltyOfferService';
import { resizeAdPostRender } from '../utilities/ads';
import '../patterns/cashbackJoinModal/cashbackJoinModal';
import { initCashbackInterstitial, loyaltyJoinTopic, outclickSelectorRegistry } from '../utilities/loyalty';
import AdRefreshEvents from '../utilities/adRefreshEvents';
// Style imports needed for rfa interstitial flows
import '../../scss/patterns/cashbackActivatorInterstitial/rfaInterstitialSuccess.scss';
import '../../scss/patterns/cashbackActivatorInterstitial/rfaInterstitialFailure.scss';
import { initPage } from '../utilities/initPage';
new LazyLoad(); // eslint-disable-line no-new
/** The name of the module */
export const name = 'DealDetails';
initPage();
// TODO: remove this when the ad stack rewrite is done.
resizeAdPostRender();
const bodyElement = document.querySelector('body');
const showCashbackInterstitial = parseInt(bodyElement.dataset.showCashbackInterstitial, 10) === 1;
const setInterstitialDataAttributesOnBody = () => __awaiter(void 0, void 0, void 0, function* () {
    const dataAttrs = {
        'data-show-cashback-interstitial': '1',
        'data-disable-cb-activated-notification': '0',
        'data-disable-cb-adblock-activated-notification': '0',
        'data-thread-id': bodyElement.dataset.threadId,
    };
    Object.keys(dataAttrs).forEach(attribute => {
        bodyElement.setAttribute(attribute, dataAttrs[attribute]);
    });
});
if (showCashbackInterstitial) {
    initCashbackInterstitial(outclickSelectorRegistry.dealDetails);
}
else {
    // initializes the cashback interstitial when a registered user activates cashback on a page
    const subscriber = Injector.get(JobSubscriberName, InjectorScope.Singleton);
    subscriber.subscribe(loyaltyJoinTopic, QOSLevels.QOS0, () => __awaiter(void 0, void 0, void 0, function* () {
        yield setInterstitialDataAttributesOnBody();
        initCashbackInterstitial(outclickSelectorRegistry.dealDetails);
    }));
}
const blueshiftObserver = new BlueshiftObserver(new Blueshift());
blueshiftObserver.observe(new DealDetailsPageViewObservable());
blueshiftObserver.observe(new DealDetailsPageOutClickObservable());
const buttonObserver = Injector.resolve(ButtonObserverName);
buttonObserver.observe(new DealDetailsPageViewObservable());
buttonObserver.observe(new DealDetailsPageOutClickObservable());
const addCashbackPromos = () => __awaiter(void 0, void 0, void 0, function* () {
    const offersJSON = yield LoyaltyOfferService.getOffers();
    const { offers, exclusiveOffers, extensionInstalled, availableTypes, } = offersJSON;
    const heap = new Heap();
    if (!Object.keys(offers).length && !Object.keys(exclusiveOffers)) {
        return;
    }
    // Retrieve exclusive offer
    const exclusiveOffer = exclusiveOffers[Object.keys(exclusiveOffers)[0]];
    // Set offer as core offer by default
    let offer = offers[Object.keys(offers)[0]];
    // If extension is installed and there's an exclusive offer, update to use exclusive offer (for core + ext offers)
    if (extensionInstalled && exclusiveOffer) {
        offer = exclusiveOffer;
    }
    // If exclusive offer exists and this is an exclusive only offer, update to use exclusive offer (ext only offers)
    if (exclusiveOffer && availableTypes === 'onlyExtension') {
        offer = exclusiveOffer;
    }
    injectCashbackTag(offer, offersJSON.availableTypes);
});
readyState.domready.then(() => __awaiter(void 0, void 0, void 0, function* () {
    (new AdRefreshEvents()).initializeAdRefreshOnUpscroll();
    try {
        yield addCashbackPromos();
        const heap = new Heap();
        if (document.querySelector('[data-role="activateCashback"]')) {
            heap.track('Rewards No Extension - Cashback Activator CTA - Impression').catch(() => { });
        }
        if (document.querySelector('[data-content="cashbackActivated"]')) {
            heap.track('Rewards No Extension - Cashback Activated - Impression').catch(() => { });
        }
    }
    catch (_a) {
        Logger.error('Unable to load loyalty offers');
    }
}));
